import React from 'react';

import { withStyles } from '@mui/styles';
import zIndex from '@mui/material/styles/zIndex';

const styles = {
  tooltip: {
    position: 'relative',
    display: 'inline-flex',
    justifyContent: 'center',
    '&:hover .arrow-tooltip': {
      visibility: 'visible',
      opacity: '1',
    },
  },
  tooltiptext: {
    opacity: '0',
    color: '#fff',
    fontSize: '11px',
    zIndex: '99999',
    whiteSpace: 'pre',
    textAlign: 'center',
    borderRadius: '3px',
    position: 'absolute',
    visibility: 'hidden',
    bottom: 'calc(100% + 5px)',
    transition: 'opacity 0.1s',
    padding: '1px 5px 2px 5px',
    backgroundColor: '#4c4c4c',
  },
  tooltipBottom: {
    top: '100%',
    bottom: 'auto',
    marginTop: '10px',
  },
  tooltipLeft: {
    left: '100%',
    bottom: 'auto',
    marginLeft: '10px',
  },
  tooltipRight: {
    right: '100%',
    bottom: 'auto',
    marginLeft: '10px',
  },
};

export default withStyles(styles)(({ style, text, classes, children, placement }) => (
  <div className={classes.tooltip} style={style}>
    <span className={`arrow-tooltip ${classes.tooltiptext} ${placement === 'bottom' ? classes.tooltipBottom : placement === 'left' ? classes.tooltipLeft : placement === 'right' ? classes.tooltipRight : ''}`}>
      {text}
    </span>
    {children}
  </div>
));
